<template>
  <div class="MyGroupNickUpdate">
    <van-nav-bar
      title="修改我在群里昵称"
      fixed
      right-text="修改"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <div class="text">昵称</div>
      <van-field v-model="groupnickname" placeholder="请输入新昵称" border clearable />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: "MyGroupNickUpdate",
  data() {
    return {
      u_id: "",
      ug_id: "",
      groupnickname: "",
      token: localStorage.getItem(localStorage.getItem("u_id") + "token")
    };
  },
  created() {
    var params = this.$route.query;
    this.u_id = params.u_id;
    this.ug_id = params.ug_id;
    this.loadData();
  },
  methods: {
    loadData() {
      var params = {
        u_id: this.u_id,
        ug_id: this.ug_id,
        token: this.token
      };
      var url = this.Conf.serverUrl + "User/getUserInfoById" + "?num="+Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          if (response.data.code == 200) {
            this.groupnickname = response.data.ug_group_nick[0].ug_group_nick;
          }
          // console.log(this.groupnickname);
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "GroupChatSet",
        query: {
          ug_id: this.ug_id
        }
      });
    },
    // 修改按钮
    onClickRight() {
      var params = {
        u_id: this.u_id,
        ug_id: this.ug_id,
        groupnickname: this.groupnickname,
        token: this.token
      };
      var url = this.Conf.serverUrl + "User/groupnicknameUpdate" + "?num="+Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          switch (response.data.code) {
            case 200:
              this.$toast.success(response.data.msg);
              break;
            case 40001:
              this.$toast.fail(response.data.msg);
              break;
          }
        })
        .catch(error => {});
    }
  },
 
};
</script>



// WEBPACK FOOTER //
// src/components/Group/MyGroupNickUpdate.vue